// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__GU9zW","links":"Footer_links__DgXSU","logo":"Footer_logo__62rtf","copyright":"Footer_copyright__ZsgNL","linkItem":"Footer_linkItem__3BU9O"};